import { createSlice, PayloadAction, createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store/store';
import { JobSiteState } from '../types';
import { jobSiteState } from './jobSiteState';

export const jobSiteSlice = createSlice({
  name: 'jobSites',
  initialState: jobSiteState,
  reducers: {
    setJobSites(state, action: PayloadAction<JobSiteState['JobSiteList']>) {
      state.JobSiteList = action.payload;
    },
    setLimit: (state, action: PayloadAction<number>) => {
      state.limit = action.payload;
    },
    setPageIndex: (state, action: PayloadAction<number>) => {
      state.pageIndex = action.payload;
    },
    setTotalRecordCounts: (state, action: PayloadAction<number>) => {
      state.totalRecordCount = action.payload;
    },
    setSortBy: (state, action: PayloadAction<string>) => {
      state.sortBy = action.payload;
    },
    setSortField: (state, action: PayloadAction<string>) => {
      state.sortField = action.payload;
    },
    setRecordId: (state, action: PayloadAction<string>) => {
      state.recordId = action.payload;
    },
    setDeleteDialog: (state, action: PayloadAction<boolean>) => {
      state.deleteDialog = action.payload;
    },
    setJobSitesToDelete: (
      state,
      action: PayloadAction<JobSiteState['JobSiteList']>,
    ) => {
      state.jobSiteToDelete = action.payload;
    },
    setJobSitesToUpdate: (
      state,
      action: PayloadAction<JobSiteState['JobSiteList']>,
    ) => {
      state.jobSiteToUpdate = action.payload;
    },
    setCreateModal: (state, action: PayloadAction<boolean>) => {
      state.createModal = action.payload;
    },
    setUpdateModal: (state, action: PayloadAction<boolean>) => {
      state.updateModal = action.payload;
    },
    setJobSiteImages: (
      state,
      action: PayloadAction<JobSiteState['jobSiteImages']>,
    ) => {
      state.jobSiteImages = action.payload;
    },
    setCsvUpload: (state, action: PayloadAction<boolean>) => {
      state.csvUpload = action.payload;
    },
    setResetData: () => jobSiteState,
  },
});

export const { actions: jobSiteActions } = jobSiteSlice;

export const selectJobSite = (state: RootState) => state.jobSites;

export const selectJobSiteList = createSelector(
  selectJobSite,
  jobSites => jobSites.JobSiteList,
);

export const selectJobSiteTableColoumns = createSelector(
  selectJobSite,
  jobSites => jobSites.columns,
);

export const selectJobSiteLimit = createSelector(
  selectJobSite,
  JobSites => JobSites.limit,
);
export const selectJobSitePageIndex = createSelector(
  selectJobSite,
  JobSites => JobSites.pageIndex,
);
export const selectJobSiteTotalRecordCount = createSelector(
  selectJobSite,
  JobSites => JobSites.totalRecordCount,
);
export const selectJobSiteSortBy = createSelector(
  selectJobSite,
  JobSites => JobSites.sortBy,
);
export const selectJobSiteSortField = createSelector(
  selectJobSite,
  JobSites => JobSites.sortField,
);
export const selectJobSiteRecordId = createSelector(
  selectJobSite,
  JobSites => JobSites.recordId,
);

export const selectDeleteDiaog = createSelector(
  selectJobSite,
  JobSites => JobSites.deleteDialog,
);

export const selectJobSiteToDelete = createSelector(
  selectJobSite,
  JobSites => JobSites.jobSiteToDelete,
);

export const selectJobSiteToUpdate = createSelector(
  selectJobSite,
  JobSites => JobSites.jobSiteToUpdate,
);

export const selectCreateModal = createSelector(
  selectJobSite,
  JobSites => JobSites.createModal,
);

export const selectUpdateModal = createSelector(
  selectJobSite,
  JobSites => JobSites.updateModal,
);

export const selectJobSiteImages = createSelector(
  selectJobSite,
  JobSites => JobSites.jobSiteImages,
);

export const selectCsvUpload = createSelector(
  selectJobSite,
  JobSites => JobSites.csvUpload,
);

export default jobSiteSlice.reducer;
